import formNames from '../../../constants/formNames';

const formName = formNames.product;

export const DUPLICATE_PRODUCT = `${formName}/DUPLICATE_PRODUCT`;
